import {
  BackgroundMediaRoot,
  BackgroundDesktop,
  BackgroundMobile,
} from "./BackgroundMedia.styles";
import bgImgDesktop from "../../assets/background/Start_screen_Desktop_new.png";
import bgImgMobile from "../../assets/background/Start_screen_Mobile_new.png";

export const BackgroundMedia = () => {
  return (
    <BackgroundMediaRoot>
      <BackgroundDesktop component="img" src={bgImgDesktop} alt="desktop" />
      <BackgroundMobile component="img" src={bgImgMobile} alt="mobile" />
    </BackgroundMediaRoot>
  );
};
